import { TmBaseError } from '@/core/error/tmBaseError'

export class TmWorkerError extends TmBaseError {
  public name = 'TmWorkerError'
}
